(() => {
  'use strict';
  if (customElements.get('fy-uk-hs-module')) return;
  const states = new Map();
  customElements.define('fy-uk-hs-module', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.buttons = [...this.querySelectorAll('[data-category]')];
      this.categoryPanels = [...this.querySelectorAll('[data-category-panel]')];
      this.roomPanels = [...this.querySelectorAll('[data-room-key]')];
      this.addEventListener('click', event => {
        const category = event.target.closest('[data-category]');
        if (category) this.selectCategory(category.dataset.category,false,category.dataset.blockId);
        const hotspot = event.target.closest('[data-category-link]');
        if (hotspot && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
          const catalog = this.page.querySelector('fy-uk-hs-module[data-kind="catalog"]');
          if (catalog?.buttons.some(b=>b.dataset.category===hotspot.dataset.categoryLink)) {
            event.preventDefault(); catalog.selectCategory(hotspot.dataset.categoryLink,true);
          }
        }
        const room = event.target.closest('[data-room]');
        if (room) this.selectRoom(room.dataset.room);
        if (event.target.closest('[data-room-next]') && this.roomPanels.length) {
          const index = this.roomPanels.findIndex(panel=>!panel.hidden);
          this.selectRoom(this.roomPanels[(index+1)%this.roomPanels.length].dataset.roomKey);
        }
        const move = event.target.closest('[data-move]');
        if (move) this.move(Number(move.dataset.move));
        const check = event.target.closest('[data-check]');
        if (check) this.toggleCheck(check);
        const anchor = event.target.closest('a[href^="#fy-uk-hs-"]');
        if (anchor && !hotspot && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
          const target = this.page.querySelector(anchor.getAttribute('href'));
          if (target) { event.preventDefault(); this.goTo(target); }
        }
      },{signal});
      this.querySelectorAll('[data-native-rail]').forEach(rail=>{
        rail.addEventListener('scroll',()=>this.updateArrows(),{signal,passive:true});
        rail.addEventListener('keydown',event=>{
          if(event.target===rail && ['ArrowLeft','ArrowRight'].includes(event.key)) {
            event.preventDefault(); this.move(event.key==='ArrowRight'?1:-1);
          }
        },{signal});
      });
      if(this.dataset.kind==='catalog') {
        this.observer=new ResizeObserver(()=>this.updateArrows());
        this.querySelectorAll('[data-native-rail]').forEach(rail=>this.observer.observe(rail));
        const previous=states.get(this.dataset.sectionId);
        this.selectCategory(null,false,previous?.categoryBlockId||this.buttons[0]?.dataset.blockId);
        this.updateArrows();
      }
      if(this.dataset.kind==='rooms') {
        const previous=states.get(this.dataset.sectionId);
        this.selectRoom(previous?.room||this.roomPanels[0]?.dataset.roomKey);
      }
      // Editor events may target Shopify's outer wrapper, so resolve the block ID directly.
      document.addEventListener('shopify:block:select',event=>{
        const blockId=event.detail?.blockId;
        const panel=this.categoryPanels.find(p=>p.dataset.blockId===blockId);
        if(panel) this.selectCategory(panel.dataset.categoryPanel,false,blockId);
        const room=this.roomPanels.find(p=>p.id==='fy-uk-hs-room-'+blockId);
        if(room) this.selectRoom(room.dataset.roomKey);
      },{signal});
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller=null; this.observer?.disconnect();
    }
    get page() { return this.closest('main')||document; }
    get reduced() { return matchMedia('(prefers-reduced-motion:reduce)').matches; }
    goTo(target) {
      const offset=(document.querySelector('store-header')?.getBoundingClientRect().height||90)+20;
      window.scrollTo({top:window.scrollY+target.getBoundingClientRect().top-offset,behavior:this.reduced?'instant':'smooth'});
      if(!target.hasAttribute('tabindex')) target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
    }
    selectCategory(key,jump=false,blockId=null) {
      const button=this.buttons.find(b=>blockId?b.dataset.blockId===blockId:b.dataset.category===key)||this.buttons[0];
      if(!button) return;
      const panel=this.categoryPanels.find(p=>p.dataset.blockId===button.dataset.blockId);
      if(!panel) return;
      states.set(this.dataset.sectionId,{categoryBlockId:button.dataset.blockId});
      this.categoryPanels.forEach(p=>{p.hidden=p!==panel;});
      this.buttons.forEach(b=>{
        const active=b===button; b.setAttribute('aria-pressed',String(active)); b.classList.toggle('selected',active);
      });
      this.activePanel=panel; this.rail=panel.querySelector('[data-native-rail]');
      this.rail.scrollTo({left:0,behavior:'instant'});
      const count=this.rail.querySelectorAll('.native-cell').length;
      this.querySelector('[data-category-status]').textContent=button.dataset.label+' / '+count+' '+this.dataset.selected;
      const link=this.querySelector('[data-category-all]');
      link.textContent=this.dataset.viewAll+' '+button.dataset.label+' \u2197';
      link.href=button.dataset.url||'/collections/all';
      requestAnimationFrame(()=>this.updateArrows());
      if(jump) {this.goTo(this.querySelector('[data-fhs-designs]'));button.focus({preventScroll:true});}
    }
    selectRoom(key) {
      if(!this.roomPanels.some(panel=>panel.dataset.roomKey===key)) return;
      states.set(this.dataset.sectionId,{room:key});
      this.roomPanels.forEach(panel=>{panel.hidden=panel.dataset.roomKey!==key;});
      this.querySelectorAll('[data-room]').forEach(button=>{
        const active=button.dataset.room===key;
        button.classList.toggle('selected',active);button.setAttribute('aria-pressed',String(active));
      });
    }
    move(direction) {
      if(!this.rail||![-1,1].includes(direction)) return;
      const cell=this.rail.querySelector('.native-cell');
      if(!cell) return;
      this.rail.scrollBy({left:direction*(cell.getBoundingClientRect().width+(parseFloat(getComputedStyle(this.rail).columnGap)||20)),behavior:this.reduced?'instant':'smooth'});
    }
    updateArrows() {
      if(!this.isConnected) return;
      const previous=this.querySelector('[data-move="-1"]'),next=this.querySelector('[data-move="1"]');
      if(!previous||!next) return;
      previous.disabled=!this.rail||this.rail.scrollLeft<2;
      next.disabled=!this.rail||this.rail.scrollLeft>=this.rail.scrollWidth-this.rail.clientWidth-2;
    }
    toggleCheck(button) {
      const active=button.getAttribute('aria-pressed')!=='true';
      button.setAttribute('aria-pressed',String(active));button.classList.toggle('done',active);
      button.querySelector('.check-box').textContent=active?'\u2713':'+';
      const all=[...this.querySelectorAll('[data-check]')],count=all.filter(b=>b.getAttribute('aria-pressed')==='true').length;
      this.querySelector('[data-plan-text]').textContent=count===all.length?this.dataset.planComplete:count===0?this.dataset.planStart:this.dataset.planProgress.replace('[count]',count).replace('[total]',all.length);
      this.querySelector('[data-plan-status]').classList.toggle('ready',count===all.length);
    }
  });
})();
